// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import cn from 'classnames';
import {Carusel} from '../carusel';
import Icon_location from '../../img/icons/location12x16.svg';
import {HP_card} from '../hp_cards';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import styles from './review_slides.module.less';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {Input} from '../../../../hola/pub/lib/input';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';

interface i_review_slide {
    name: string;
    country: string;
    title: string;
    text: string;
}

const default_review_slides = [
    {
        name: 'Andrew',
        country: 'US',
        title: 'Reliable proxies for web scraping',
        text: `I needed reliable proxies for web scraping and bypassing
            CAPTCHAs, and Toolip offered the best mix of pricing and
            performance. Their flate rate pricing and no hidden costs were
            essential in my decision. The uptime and speed have been
            impressive.`,
    },
    {
        name: 'Danylo',
        country: 'AU',
        title: 'Shared Datacenter',
        text: `Used their Shared Datacenter, handled big volume of data fast.
            Very cool.`,
    },
    {
        name: 'Jo Appel',
        country: 'BE',
        title: 'Quality Service',
        text: `It's not often you get quality service that's also friendly.
            Kudos`,
    },
    {
        name: 'Greg M',
        country: 'PL',
        title: 'The product works',
        text: `The product works. They offer great performance.`,
    },
    {
        name: 'Daniel Silverstein',
        country: 'CA',
        title: 'Toolip\'s web scraping proxies worked',
        text: `Toolip's web scraping proxies worked well for me. They are user
            friendly and efficient.`,
    },
    {
        name: 'LA',
        country: 'BE',
        title: 'Je viens de Belgique et j\'utilise les…',
        text: `Je viens de Belgique et j'utilise les proxys de Toolip.io depuis
            un moment maintenant et j'en suis très satisfait. Ils sont rapides
            et fiables, et le service client est toujours amical et
            serviable.`,
    },
    {
        name: 'SR',
        country: 'US',
        title: 'Perfect for web scraping!',
        text: `Toolip.io has some of the best proxies I've ever used. They are
            perfect for web scraping.`,
    },
    {
        name: 'Mike',
        country: 'US',
        title: 'Reliable proxies with excellent onboarding support',
        text: `I need reliable proxies for daily scraping of e commerce sites
            for products and pricing data. Their ISP proxies I used managed the
            bot defenses well. Their onboarding support was excellent, and I
            appreciate the simplicity of their process.`,
    },
].map(item=>({
    id: item.name,
    title: <div className={styles.review_slide_title}>
      <p>{item.name} <span><Icon_location/> {item.country}</span></p>
      <h4>{item.title}</h4>
    </div>,
    text: item.text,
}));

interface i_review_slides_props {
    slides?: i_review_slide[];
    title?: string;
    title_tag?: string;
    subtitle?: string;
}

export const Review_slides = (props: i_review_slides_props)=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    const {is_client, width} = use_screen();
    const slide_width = width < 768 ? 335 : 448;
    const slide_height = width < 768 ? 448 : 376;
    const review_slides = (props.slides || default_review_slides).map(item=>({
        id: item.name,
        title: <div className={styles.review_slide_title}>
          <p>{item.name} <span><Icon_location/> {item.country}</span></p>
          <h4>{item.title}</h4>
        </div>,
        text: item.text,
    }));
    return <section className={styles.review_slides}>
      <Dynamic_heading tag={props.title_tag || 'h2'}>
        {<T>{props.title || 'Top Rated Proxies'}</T>}</Dynamic_heading>
      <p className={theme.u1}>
        <T>{props.subtitle || 'See what people are saying about toolip!'}</T></p>
      {is_client && <Carusel items={review_slides.map((s, i)=>{
        const color = i%4==0 ? 'green'
          : i%4==1 ? 'blue'
          : i%4==2 ? 'pink'
          : 'purple';
        const slide_cls = cn(styles.review_slide);
        return <HP_card key={s.id} {...s} cls={slide_cls} show
          color={color}/>;
        })} slide_width={slide_width} slide_height={slide_height}
        list={width < 480 ? 2 : 0} show_more='Show more reviews'/>}
    </section>;
};

interface i_review_slide_editor_props {
    value: i_review_slides_props;
    on_change: (value: i_review_slides_props)=>void;
}

export const Review_slides_editor = (props: i_review_slide_editor_props)=>{
    const {value, on_change} = props;
    return <div>
      <Input
        value={value.title || ''}
        on_change={v=>on_change({...value, title: v})}
        label='Section Title'
      />
      <Title_header_select value={value.title_tag} on_select={v=>
        on_change({...value, title_tag: v})}/>
      <Input
        value={value.subtitle || ''}
        on_change={v=>on_change({...value, subtitle: v})}
        label='Section Subtitle'
      />
    </div>;
};
